// @flow

import React from 'react';
import Row from 'react-aaui/lib/grid/Row';
import injectL10n from 'react-aaui/lib/shared/injectL10n';
import Col from 'components/Col/Col';
import ResultData from 'components/ResultData/ResultData';
import ResultCard from 'components/ResultCard/ResultCard';
import ResultCardContainer from 'components/ResultCardContainer/ResultCardContainer';
import { formatedDuration } from 'services/format/formatDuration';
import getFinalResult from 'services/getFinalResult/getFinalResult';

import type { L10n } from 'type/type';

import IssueReportIcon from '../../IssueReportIcon/IssueReportIcon';
import './ParticipantFinalResultBoard.scss';

type Props = {
  l10n: L10n,
  finalResult: string,
  participatedRoute: string,
  participantLongId: ?number
}

const ParticipantFinalResultBoard = ({
  finalResult, participatedRoute, participantLongId,
  l10n: { formatMessage },
}: Props) => {
  const { gunTimeResult, chipTimeResult } = finalResult || {};
  const { useChipTime } = participatedRoute || {};
  const displayGunTime = gunTimeResult ? formatedDuration(gunTimeResult) : '--';
  const displayChipTime = chipTimeResult ? formatedDuration(chipTimeResult) : '--';
  const finalResultData = finalResult && getFinalResult(useChipTime, finalResult);
  const displayFinalResults = finalResultData ? formatedDuration(finalResultData) : '--';

  return (
    <ResultCardContainer>
      <Row className="final-result">
        <Col span={8}>
          <ResultCard logo="icon-finish">
            <ResultData
              type={formatMessage('page.participant.participantHeader.finalResults')}
              data={displayFinalResults}
              dataFont={32} />
          </ResultCard>
        </Col>
        <Col span={4}>
          {<IssueReportIcon participantLongId={participantLongId} />}
        </Col>
      </Row>
      <Row className="second-row">
        <Col>
          <ResultCard logo="">
            <Row gutter={5} fluid>
              <Col span={6}>
                <ResultData
                  type={formatMessage('page.participant.participantHeader.gunTime')}
                  data={displayGunTime}
                  dataFont={20} />
              </Col>
              <Col span={6}>
                <ResultData
                  type={formatMessage('page.participant.participantHeader.chipTime')}
                  data={displayChipTime}
                  dataFont={20} />
              </Col>
            </Row>
          </ResultCard>
        </Col>
      </Row>
    </ResultCardContainer>
  );
};

export default injectL10n()(ParticipantFinalResultBoard);
